<template>
  <!-- header -->
  <HeaderComponentVue></HeaderComponentVue>

  <!-- menus -->
  <MenuComponentVue></MenuComponentVue>

  <!-- center -->
  <div id="center">
    <!-- center - contents -->
    <div id="main-contents">
      <router-view />
    </div>
  </div>

  <!-- footer -->
  <div id="footer">
    <div class="footer-content">
      <div class="footer-links">
        <router-link to="/">소개</router-link>
        <span class="footer-sep">|</span>
        <router-link to="/user/terms-of-service">이용약관</router-link>
        <span class="footer-sep">|</span>
        <router-link to="/user/terms">개인정보 처리방침</router-link>
        <span class="footer-sep">|</span>
        <a href="mailto:purecrystar@gmail.com">purecrystar@gmail.com</a>
      </div>
      <div class="footer-copy">&copy; 2026 Breezer. All rights reserved.</div>
    </div>
  </div>

  <!-- scroll to top -->
  <transition name="fade">
    <button
      v-if="showScrollTop"
      id="scroll-top-btn"
      @click="scrollToTop"
      aria-label="맨 위로"
    >
      ▲
    </button>
  </transition>

  <!-- cookie consent -->
  <CookieConsent />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import { useStore, mapState } from "vuex";
import HeaderComponentVue from "@/common/components/HeaderComponent.vue";
import MenuComponentVue from "@/common/components/MenuComponent.vue";
import CookieConsent from "@/common/components/CookieConsent.vue";


export default defineComponent({
  name: "App",
  setup() {
    const store = useStore();
    const showScrollTop = ref(false);

    const onScroll = () => {
      showScrollTop.value = window.scrollY > 300;
    };

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    onMounted(() => {
      window.addEventListener("scroll", onScroll);
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", onScroll);
    });

    return {
      store,
      showScrollTop,
      scrollToTop,
    };
  },

  data() {
    return {
      //
    };
  },
  components: {
    HeaderComponentVue,
    MenuComponentVue,
    CookieConsent,
  },
  computed: {
    //
  },
  methods: {
    //
  },
  async created() {
    //
    console.info("[App] created");
  },
});
</script>
